"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var common_1 = require("@angular/common");
/**
 * Applies language direction on root (html) element when language is changed
 */
var LanguageDirectionDirective = /** @class */ (function () {
    function LanguageDirectionDirective(currentLanguageProvider, _document) {
        this.currentLanguageProvider = currentLanguageProvider;
        this._document = _document;
    }
    LanguageDirectionDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._languageSubscription = this.getCurrentLanguage()
            .subscribe(function (language) {
            _this._document.dir = language.getDirection() === idm_crosscutting_concepts_frontend_1.LanguageDirection.LTR ? 'ltr' : 'rtl';
        });
    };
    LanguageDirectionDirective.prototype.ngOnDestroy = function () {
        this._languageSubscription.unsubscribe();
    };
    /**
     * @returns Current Language
     */
    LanguageDirectionDirective.prototype.getCurrentLanguage = function () {
        return this.currentLanguageProvider.getCurrentLanguage();
    };
    LanguageDirectionDirective = __decorate([
        core_1.Directive({
            selector: '[langDir]'
        }),
        __param(1, core_1.Inject(common_1.DOCUMENT)),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider, Object])
    ], LanguageDirectionDirective);
    return LanguageDirectionDirective;
}());
exports.LanguageDirectionDirective = LanguageDirectionDirective;
//# sourceMappingURL=language-direction.directive.js.map